import "./App.css";
import React from "react";
import { SnackbarProvider } from 'notistack';
import {BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from "./Home"
import VideoDisplay from "./VideoDisplay"
export const config = {linked: "https://xflix-node-lce3.onrender.com/v1/videos"}
function App(props) {
 
  return (
    <SnackbarProvider>
    <Router>
    <div className="App">
    <Switch>
        <Route exact path="/">
          <Home/>
        </Route>
        <Route exact path="/:videoId">
          <VideoDisplay/>
        </Route>
    </Switch>
    </div>
    </Router>
    </SnackbarProvider>
  );
  
}

export default App;
